import React, {useEffect, useState} from "react";
import {Funnel, MapPinned} from "lucide-react";
import { Drawer } from "vaul";
import '../App.css';

export default function FiltersBlock({ filter, setFilter, problemFilters, location, setLocation, locationFilters }) {
    const [problemsFilterOpen, setProblemFilterOpen] = useState(false);
    const [locationFilterOpen, setLocationFilterOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(true);
    useEffect(() => {
        const isTouchScreenDevice = () => {
            try{
                document.createEvent('TouchEvent');
                return true;
            }catch(e){
                return false;
            }
        }

        setIsMobile(isTouchScreenDevice());
    }, []);

    if (!isMobile) {
        return (
            <div style={{ marginBottom: "20px", textAlign: "center" }}>
                <button onClick={() => setFilter(null)} style={{ marginTop: '12px'}} className={filter === null ? 'button-secondary' : ''}>Все</button>
                {problemFilters.map(f => {
                    return (
                        <button key={f.id} onClick={() => setFilter(f.id)} style={{marginLeft: "12px", marginTop: '12px'}} className={filter === f.id ? 'button-secondary' : ''}>{f.title}</button>
                    )
                })}
            </div>
        );
    }

    return (
        <div style={{
            width: '100%',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px"
        }}>
            <Drawer.Root open={problemsFilterOpen} onOpenChange={setProblemFilterOpen}>
                <Drawer.Trigger>
                    <Funnel />
                </Drawer.Trigger>
                <Drawer.Portal>
                    <Drawer.Overlay style={{ position: 'fixed', inset: '0', backgroundColor: 'rgba(0,0,0,0.4)' }} />
                    <Drawer.Content style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: '3rem',
                        position: 'fixed',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        height: '96%',
                        backgroundColor: '#fff',
                        borderRadius: '1rem 1rem 0 0',
                        zIndex: 999,
                    }}>
                        <div className="p-4 bg-white rounded-t-[10px] flex-1" style={{ backgroundColor: '#fff', padding: '1rem', borderRadius: '15px 15px 0 0'}}>
                            <div className="mx-auto w-12 h-1.5 flex-shrink-0 rounded-full bg-zinc-300 mb-8" style={{
                                margin: '1rem auto 2rem auto',
                                width: '120px',
                                height: '5px',
                                flexShrink: '0',
                                backgroundColor: 'rgb(212,212,216)',
                                borderRadius: '15px'
                            }}
                            />
                            <div className="max-w-md mx-auto">
                                <Drawer.Title style={{ marginBottom: '1rem', textAlign: 'center' }}>
                                    Быстрые фильтры
                                </Drawer.Title>
                                <div style={{ marginBottom: "20px" }}>
                                    <button onClick={() => { setFilter(null); setProblemFilterOpen(false) } } style={{ marginTop: '12px', marginLeft: '12px'}} className={filter === null ? 'button-secondary' : ''}>Все</button>
                                    {problemFilters.map(f => {
                                        return (
                                            <button key={f.id} onClick={() => { setFilter(f.id); setProblemFilterOpen(false) } } style={{marginLeft: "12px", marginTop: '12px'}} className={filter === f.id ? 'button-secondary' : ''}>{f.title}</button>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </Drawer.Content>
                </Drawer.Portal>
            </Drawer.Root>

            <Drawer.Root open={locationFilterOpen} onOpenChange={setLocationFilterOpen}>
                <Drawer.Trigger>
                    <MapPinned />
                </Drawer.Trigger>
                <Drawer.Portal>
                    <Drawer.Overlay style={{ position: 'fixed', inset: '0', backgroundColor: 'rgba(0,0,0,0.4)' }} />
                    <Drawer.Content style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: '3rem',
                        position: 'fixed',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        height: '96%',
                        backgroundColor: '#fff',
                        borderRadius: '1rem 1rem 0 0',
                        zIndex: 999,
                    }}>
                        <div className="p-4 bg-white rounded-t-[10px] flex-1" style={{ backgroundColor: '#fff', padding: '1rem', borderRadius: '15px 15px 0 0'}}>
                            <div className="mx-auto w-12 h-1.5 flex-shrink-0 rounded-full bg-zinc-300 mb-8" style={{
                                margin: '1rem auto 2rem auto',
                                width: '120px',
                                height: '5px',
                                flexShrink: '0',
                                backgroundColor: 'rgb(212,212,216)',
                                borderRadius: '15px'
                            }}
                            />
                            <div className="max-w-md mx-auto">
                                <Drawer.Title style={{ marginBottom: '1rem', textAlign: 'center' }}>
                                    Место встречи
                                </Drawer.Title>
                                <div style={{ marginBottom: "20px" }}>
                                    <button onClick={() => { setLocation(null); setLocationFilterOpen(false) } } style={{ marginTop: '12px', marginLeft: '12px'}} className={location === null ? 'button-secondary' : ''}>Все</button>
                                    {locationFilters.map(f => {
                                        return (
                                            <button key={f.id} onClick={() => { setLocation(f.id); setLocationFilterOpen(false) } } style={{marginLeft: "12px", marginTop: '12px'}} className={location === f.id ? 'button-secondary' : ''}>{f.label}</button>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </Drawer.Content>
                </Drawer.Portal>
            </Drawer.Root>

        </div>
    )
}
